(function () {
  const init = () => {
    const nav = document.querySelector(".global-nav");
    const buttons = document.querySelectorAll(".header-menu-button");

    if (!nav || !buttons.length) return;

    const toggle = () => {
      const opened = nav.classList.toggle("is-open");
      document.body.style.overflow = opened ? "hidden" : "";
      buttons.forEach((btn) =>
        btn.setAttribute("aria-expanded", String(opened))
      );
    };

    buttons.forEach((btn) => btn.addEventListener("click", toggle));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
